import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const FormAddClient = () => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [vat, setVat] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const saveClient = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/clients`, {
        headers: {
            'X-API-Key': API_KEY
        },
        name: name,
        address: address,
        vat: vat,
        email: email,
        phone: phone,
      });
      navigate("/clients");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Create Client/Customer</h1>
          <div className="card is-shadowless">
            <form onSubmit={saveClient}>
              <p className="has-text-centered">{msg}</p>
              <div className="field">
                <label className="label">Name</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Name"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Address</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Address"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Email</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Phone</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone"
                  />
                </div>
              </div>                 
              <div className="field">
                <label className="label">VAT</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={vat}
                    onChange={(e) => setVat(e.target.value)}
                    placeholder="VAT"
                  />
                </div>
              </div>
              <div className="field">
                <div className="control">
                  <Link to="/clients">
                  <button className="button is-small is-warning mr-1">
                    Cancel
                  </button>
                  </Link>
                  <button type="submit" className="button is-small is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddClient;
